import React from "react";
import CashoutRequests from "../components/cashout";
import RightMenu from "../components/widgets/offcanvas";
import { useSelector, useDispatch } from "react-redux";
import { RightOffClear } from "../redux/slices/offcanvas";
import GetUserDatas from "../components/widgets/user";
export function CashoutPage() {
  const dispatch = useDispatch();
  const datas = useSelector((v) => v.rtl);

  return (
    <div>
      <CashoutRequests />
      <RightMenu
        children={<GetUserDatas />}
        status={datas?.status}
        close={() => dispatch(RightOffClear())}
      />
    </div>
  );
}

export default CashoutPage;
